import React, { useCallback, useEffect, useState } from "react";
import { Modal, Tabs, message } from "antd";
import TemplateEditor from "./TemplateEditor";
import TemplateList from "./TemplateList";
import TemplateLibrary from "./TemplateLibrary";
import styles from "./templates.module.css";

const TAB_LIST = "LIST";
const TAB_LIBRARY = "LIBRARY";
const TAB_EDITOR = "EDITOR";

export default function TemplateManager({ messaging }) {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(TAB_LIST);
  const [editing, setEditing] = useState(null);

  const load = useCallback(() => {
    if (!messaging) return;
    setLoading(true);
    messaging
      .getTemplates()
      .then((data) => setTemplates(data.templates || []))
      .catch((err) =>
        message.error(err.response?.data?.message || err.message || "Could not load templates")
      )
      .finally(() => setLoading(false));
  }, [messaging]);

  useEffect(() => {
    load();
  }, [load]);

  const confirmDelete = (template) => {
    Modal.confirm({
      title: "Delete template",
      content: template.name,
      okText: "Delete",
      okButtonProps: { danger: true },
      onOk: async () => {
        try {
          await messaging.deleteTemplate(undefined, template.name);
          message.success("Template deleted");
          load();
        } catch (err) {
          message.error(err.response?.data?.message || err.message || "Delete failed");
        }
      },
    });
  };

  const onLibrarySelect = (libTemplate) => {
    setEditing({
      ...libTemplate,
      isFromLibrary: true,
      id: undefined, // New creation
    });
    setActiveTab(TAB_EDITOR);
  };

  const onEdit = (template) => {
    setEditing(template);
    setActiveTab(TAB_EDITOR);
  };

  const onCreateNew = () => {
    setEditing(null);
    setActiveTab(TAB_EDITOR);
  };

  const onSaveComplete = () => {
    setActiveTab(TAB_LIST);
    load();
  };

  const items = [
    {
      key: TAB_LIST,
      label: "Message Templates",
      children: (
        <TemplateList
          templates={templates}
          loading={loading}
          onCreate={onCreateNew}
          onEdit={onEdit}
          onDelete={confirmDelete}
        />
      ),
    },
    {
      key: TAB_LIBRARY,
      label: "Create From Library",
      children: (
        <TemplateLibrary
          messaging={messaging}
          onSelect={onLibrarySelect}
        />
      ),
    },
    {
      key: TAB_EDITOR,
      label: editing ? "Edit Template" : "Create Template",
      children: (
        <TemplateEditor
          template={editing}
          messaging={messaging}
          onCancel={() => setActiveTab(TAB_LIST)}
          onSaved={onSaveComplete}
        />
      ),
    },
  ];

  return (
    <div className={styles.manager}>
      <div className={styles.pageTitle}>
        <h2>WhatsApp Templates</h2>
      </div>
      <div className={styles.tabWrapper}>
        <Tabs 
          activeKey={activeTab} 
          onChange={setActiveTab} 
          items={items} 
          className={styles.mainTabs}
        />
      </div>
    </div>
  );
}
